import React from 'react';
import _get from 'lodash/get';
import getAllLocations from '@testnotify/core/api/fetch-routable-location-list';
import getLocation from '@testnotify/core/api/fetch-location';
import injectSheet from 'react-jss';
import dynamic from 'next/dynamic';

// Components
import Page from '../components/Page';
import Head from 'next/head';
const SetupNotificationsWizard = dynamic(import('../components/SetupNotificationsWizard'));

interface Props {
  classes: any;
}

class SetupNotificationsPage extends React.PureComponent<Props> {
  static async getInitialProps(ctx) {
    const { testLocationPath } = ctx.query;

    const { testLocations } = await getAllLocations()
      .then(({ locations }) => {
        return {
          testLocations: locations,
        };
      })
      .catch(error => {
        return {
          testLocations: undefined,
        };
      });

    const testLocationData =
      testLocationPath &&
      (await getLocation(testLocationPath)
        .then(({ location, meta }) => {
          return {
            testLocation: location,
            identifiers: meta.identifiers,
          };
        })
        .catch(error => {
          return {
            testLocation: undefined,
            identifiers: undefined,
          };
        }));

    return {
      testLocations,
      testLocation: _get(testLocationData, 'testLocation'),
      identifiers: _get(testLocationData, 'identifiers'),
    };
  }

  render() {
    const { classes, testLocation, testLocations } = this.props as any;

    return (
      <>
        <Head>
          <title>Setup Notifications - TestNotify</title>
          <meta name="description" content="Setup notifications for testing centers." />
        </Head>
        {SetupNotificationsWizard && (
          <Page classes={{ children: classes.root }} hideLinks={true}>
            <SetupNotificationsWizard testLocation={testLocation} testLocations={testLocations} />
          </Page>
        )}
      </>
    );
  }
}

const styles = theme => {
  return {
    root: {
      marginTop: 0,
      paddingTop: 0,
      paddingBottom: theme.spacing.unit * 4,
      alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'center',
      minHeight: '85vh',
    },
  };
};

export default injectSheet(styles)(SetupNotificationsPage);
